import React, { useState } from 'react'
import { Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import PlusIcon from 'mdi-react/PlusIcon'
import { WhiteGreyBtn } from 'Stories/Button/Button.stories'
import { colors } from 'Styled/variables'
import {
  getWindowDimensions,
  useWindowDimensions,
} from '../../../../Helpers/useWindowDimensions'
import AddPlaylistForm from '../AddPlaylistForm'

import * as S from './styles'
import * as P from './props'

const ModalComponent: React.FunctionComponent<P.AddPlaylistModalProps> = ({
  onCheckPlaylist,
  isLoading,
  setIsLoading,
  setRecentlyAddedPlaylist,
}) => {
  const { t } = useTranslation()
  const [modal, setModalValue] = useState(false)

  const toggle = () => setModalValue(!modal)

  const { isMobile } = getWindowDimensions()
  useWindowDimensions()
  return (
    <div className="add_playlist_modal">
      <WhiteGreyBtn
        color={isMobile ? 'whiteFull' : 'white'} // @ts-ignore
        disabled={isLoading}
        onClick={toggle}
      >
        <S.IconContainer>
          <PlusIcon size="16" color={colors.green} />
        </S.IconContainer>
        {t('playlistsPage.addManually')}
      </WhiteGreyBtn>

      <Modal
        fade={false}
        className="modal-dialog--success modal-dialog--header"
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <h4 className="text-modal  modal__title">
            {t('playlistsPage.addSpotifyPlaylist')}
          </h4>
        </div>
        <div className="spotify-url-form-wrapper">
          <AddPlaylistForm
            toggle={toggle}
            setRecentlyAddedPlaylist={setRecentlyAddedPlaylist}
            isLoading={!!isLoading}
            // @ts-ignore
            setIsLoading={setIsLoading}
            onCheckPlaylist={onCheckPlaylist}
          />
        </div>
      </Modal>
    </div>
  )
}

export default ModalComponent
